import { parseNumber } from "../../../shared/utils/number-utils.service";

export function toDayKey(d: string | Date) {
  const dt = new Date(d);
  dt.setHours(0, 0, 0, 0);
  return dt.toISOString().slice(0, 10);
}

export const sum = (xs: number[]) =>
  xs.reduce((a, b) => a + parseNumber(b || 0), 0);

export function wAvg(values: number[], weights: number[]) {
  const w = sum(weights);
  return w
    ? values.reduce((a, v, i) => a + v * parseNumber(weights[i] || 0), 0) / w
    : 0;
}

export function buildHistogram(values: number[], binsCount?: number) {
  if (!values.length)
    return {
      bins: [] as { from: number; to: number; count: number }[],
      p10: 0,
      p90: 0,
    };
  const sorted = [...values].sort((a, b) => a - b);
  const p = (t: number) => {
    const i = (sorted.length - 1) * t,
      lo = Math.floor(i),
      hi = Math.ceil(i);
    return lo === hi
      ? sorted[lo]
      : sorted[lo] * (1 - (i - lo)) + sorted[hi] * (i - lo);
  };
  const min = sorted[0],
    max = sorted[sorted.length - 1];
  const k = binsCount ?? Math.max(3, Math.ceil(Math.log2(values.length) + 1));
  const step = (max - min) / k || 1;
  const bins = Array.from({ length: k }, (_, i) => ({
    from: min + i * step,
    to: min + (i + 1) * step,
    count: 0,
  }));
  for (const v of values)
    bins[Math.min(k - 1, Math.floor((v - min) / step))].count++;
  return { bins, p10: p(0.1), p90: p(0.9) };
}

// ✅ groupBy maison (typage sûr)
export function groupBy<T, K extends PropertyKey>(
  arr: readonly T[] | undefined,
  key: (x: T) => K,
): Record<K, T[]> {
  const out = {} as Record<K, T[]>;
  if (!arr?.length) return out;
  for (const item of arr) {
    const k = key(item);
    (out[k] ||= []).push(item);
  }
  return out;
}

// (optionnel) version Map si tu préfères
export function groupByMap<T, K>(
  arr: readonly T[] | undefined,
  key: (x: T) => K,
): Map<K, T[]> {
  const m = new Map<K, T[]>();
  if (!arr?.length) return m;
  for (const it of arr) {
    const k = key(it);
    const bucket = m.get(k);
    bucket ? bucket.push(it) : m.set(k, [it]);
  }
  return m;
}
